module.exports = __webpack_public_path__ + "img/tuxsuite_green_icons-01.b510421b.png";